<template>
  <div class="map">
    <wj-flex-map
      header="地図上の州を選択すると、その州のデータが表示されます"
      :initialized="initialized"
      :tooltipContent="tooltipContent"
    >
      <wj-geo-map-layer url="data/US.json" :itemsSourceChanged="zoomTo">
      </wj-geo-map-layer>
      <wj-flex-chart-legend position="Left" />
    </wj-flex-map>
    <div class="legend">
      <label htmlFor="legend">マップの凡例:</label>
      <select
        id="legend"
        class="control legend-select"
        v-model="currentValue"
        @change="selectSource($event.target)"
      >
        <option
          v-for="source in sources"
          :key="source.value"
          :value="source.value"
        >
          {{ source.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { isIE, Globalize } from "@mescius/wijmo";
import { Palettes } from "@mescius/wijmo.chart";
import { ColorScale } from "@mescius/wijmo.chart.map";

export default {
  name: "GdashMap",
  data: function () {
    return {
      map: null,
      currentValue: "",
      selectedIndex: 0,
      sources: [
        { name: "なし", value: "" },
        {
          name: "年齢中央値",
          value: "medianAge",
          fmtLegend: "n0",
          fmtTooltip: '"年齢: "n1',
        },
        {
          name: "住宅価格",
          value: "medianHomeValueMort",
          fmtLegend: 'c0,"k"',
          fmtTooltip: '"住宅価格: "c1,"k"',
        },
        {
          name: "世帯収入",
          value: "medianIncome",
          fmtLegend: 'c0,"k"',
          fmtTooltip: '"世帯収入: "c1,"k"',
        },
        {
          name: "純資産価値",
          value: "netWorth",
          fmtLegend: 'c0,"k"',
          fmtTooltip: '"純資産価値: "c1,"k"',
        },
        {
          name: "人口",
          value: "popTotal",
          fmtLegend: 'n0,,"m"',
          fmtTooltip: '"人口: "n1,,"m"',
        },
      ],
    };
  },
  props: {
    palette: Array,
    dataService: Object,
  },
  methods: {
    initialized(map) {
      this.map = map;
      map.hostElement.addEventListener("click", (e) => {
        if (e && e.srcElement.tagName !== "BUTTON") {
          let ht = map.hitTest(e);
          if (ht && ht.item) {
            this.selectedName = ht.item.name;

            const code = Number(ht.item.fips.toString().slice(2));
            this.$emit(
              "dataChanged",
              this.dataService.getData(code),
              ht.item.name
            );

            map.layers[0]._clearCache();
            map.invalidate();
          } else {
            //this.selectedName = null;
          }
        }
      });

      let self = this;
      map.rendered.addHandler(function (s, a) {
        const layer = map.layers[0];
        const g = layer._g;
        if (g && self.selectedName) {
          let list = [];
          for (let i = 0; i < g.childNodes.length; i++) {
            const node = g.childNodes[i];
            let id = node.getAttribute("wj-map:id");
            let f = layer._getFeatureById(id);
            if (f.properties.name === self.selectedName) {
              let sw = isIE() ? 3 * a.engine.scale : 3;
              node.setAttribute("stroke", self.palette[0]);
              node.setAttribute("stroke-width", sw.toString());
              list.push(node);
            }
          }
          list.forEach((el) => el.parentNode.appendChild(el));
        }
      });
    },
    zoomTo() {
      this.map.zoomTo(this.map.layers[0].getGeoBBox());
    },
    selectSource(target) {
      this.selectedIndex = target.selectedIndex;
      if (target.value) {
        this.map.layers[0].colorScale = new ColorScale({
          binding: (o) => this.binding(o.properties, target.value),
          colors: Palettes.SequentialSingle.Blues,
          format: this.sources[this.selectedIndex].fmtLegend,
        });
      } else {
        this.map.layers[0].colorScale = null;
      }

      this.map.layers[0]._clearCache();
      this.map.invalidate();
    },
    binding(o, name) {
      const key = Number(o.fips.toString().slice(2));
      const item = this.dataService.getData(key);
      return item ? item[name] : 0;
    },
    tooltipContent(o) {
      const source = this.sources[this.selectedIndex];
      const val = this.binding(o, source.value);
      if (val) {
        return `<b>${o.name}</b><br>${Globalize.formatNumber(
          val,
          source.fmtTooltip
        )}`;
      } else {
        return o.name;
      }
    },
  },
};
</script>
